module.exports = __webpack_public_path__ + "static/Madical_App_Dev-795ab0b8771fac58fb9844e5a134a251.png";